"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const ErrorBoundary_1 = __importDefault(require("../pageParts/ErrorBoundary"));
/**
 * Right panel widget displaying the contributions in parameter. This class is
 * not to be extended. @see Contribution for how to provide widgets at this
 * location.
 *
 * @param param0
 * @returns
 */
const RightPanel = (_a) => {
    var { contributions } = _a, props = __rest(_a, ["contributions"]);
    const rightPanelRef = react_1.default.useRef(null);
    const contributionElements = react_1.default.useMemo(() => contributions
        .filter((contrib) => contrib.section === undefined || contrib.section === props.activeSection)
        .map((contrib) => contrib.create(Object.assign(Object.assign({}, props), { key: `rightPanelEl${contrib.id}`, parentRef: rightPanelRef }))), [props.activeSection, props.availableRoutingModes]);
    // Reset ref scroll position when changing section
    react_1.default.useEffect(() => {
        var _a;
        (_a = rightPanelRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ left: 0, top: 0 });
    }, [props.activeSection]);
    return (react_1.default.createElement("section", { ref: rightPanelRef, id: "tr__right-panel" },
        react_1.default.createElement("div", { className: "tr__right-panel-inner" },
            react_1.default.createElement(ErrorBoundary_1.default, { key: props.activeSection }, contributionElements))));
};
exports.default = RightPanel;
//# sourceMappingURL=RightPanel.js.map